<template>
  <div>
    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">ADS Americas</h2>
            </div>
          </div>
        </div>
      </div>
    </section>


        <div class="container">

          <div class="columns mt-01">
            <div class="column is-4">
              <div class="video-container">
                <img src="assets/img/ads-americas/1.jpg" alt="Hace un momento tuve una intervención en el panel 'Trabajo decente, libertad sindical y diálogo social' de @ADS_Americas. @CROC_Nacional"/>
              </div>
              <p class="has-text-justified">Hace un momento tuve una intervención en el panel "Trabajo decente, libertad sindical y diálogo social" de @ADS_Americas. @CROC_Naciona</p>
            </div>

            <div class="column is-4">
              <div class="video-container">
                <img src="assets/img/ads-americas/2.jpg" alt="La libertad sindical no está peleada con la oportunidad de la colectividad de las negociaciones en beneficio de trabajadores. @ADS_Americas"/>
              </div>
              <p class="has-text-justified">La libertad sindical no está peleada con la oportunidad de la colectividad de las negociaciones en beneficio de trabajadores. @ADS_Americas</p>
            </div>

            <div class="column is-4">
              <div class="video-container">
                <img src="assets/img/ads-americas/3.jpg" alt="La Reforma Laboral de México fortalecerá a las organizaciones sindicales, ya que afianzará nuestra legitimidad. @ADS_Americas"/>
              </div>
              <p class="has-text-justified">La Reforma Laboral de México fortalecerá a las organizaciones sindicales, ya que afianzará nuestra legitimidad. @ADS_Americas</p>
            </div>

          </div>

          <div class="columns mt-01">
            <div class="column is-4">
              <div class="video-container">
                <img src="assets/img/ads-americas/4.jpg" alt="En México, el futuro del trabajo que queremos es con diálogo social constructivo entre trabajadores, empresarios y gobierno. @ADS_Americas"/>
              </div>
              <p class="has-text-justified">En México, el futuro del trabajo que queremos es con diálogo social constructivo entre trabajadores, empresarios y gobierno. @ADS_Americas</p>
            </div>

          </div>

        </div>

  </div>
</template>

<script>

export default {
  name: 'ADSAmericas',
  data () {
    return {
    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ADSAmericas.vue